import Suppliers from '@/constants/suppliers';
import { ShippingFilterState } from '@/components/customers/product/productBody/sidebar/QuickShipSwitch';
import QuickShipFabrics from '@/components/customers/product/productBody/sidebar/fabric/QuickShipFabrics';

export const QUICK_SHIP_DELIVERY_ESTIMATES = {
  leadTime: 5,
  shippingWindow: 2
};

export function isQuickShip(product) {
  return (
    parseInt(product.supplier?.id, 10) ===
      Suppliers.ADVANCED_DIGITAL_TEXTILES && !!product.uses_inventory
  );
}

export function getFilteredFabrics(
  shippingFilter,
  featuredFabrics,
  productData
) {
  return shippingFilter === ShippingFilterState.MADE_TO_ORDER
    ? featuredFabrics
    : featuredFabrics.filter(fabric => isFabricQuickShip(fabric, productData));
}

export function isFabricQuickShip(fabric, productData) {
  const fabricId = parseInt(fabric.id, 10);
  const supplierId = parseInt(productData.supplier.id, 10);
  return (
    supplierId === Suppliers.ADVANCED_DIGITAL_TEXTILES &&
    QuickShipFabrics.includes(fabricId)
  );
}
